import { FaTags } from 'react-icons/fa';

import { currencyFormat } from 'legacy/common/utils/currency';
import { getDiscountCodeByCode } from 'legacy/events/hooks';
import { Trans, useTranslation } from 'react-i18next';

function DiscountCode({ eventId, code }) {
  const { t } = useTranslation(['checkout', 'events']);
  const { data: discountCode, isLoading } = getDiscountCodeByCode(
    eventId,
    code
  );

  return !isLoading && discountCode ? (
    <div className="w-full rounded-lg bg-primary-200 flex items-center p-4">
      <div className="text-xl">
        <FaTags />
      </div>
      <div className="flex flex-col ml-4">
        {discountCode?.discount ? (
          <>
            <div className="flex flex-row">
              <Trans
                i18nKey="checkout:discountCodeApplied"
                components={{
                  strong: <strong className="mr-1" />
                }}
                values={{ code: discountCode.code }}
              />
            </div>
            <div className="text-gray-400">
              {t('checkout:amountOff', {
                amount:
                  discountCode.discount.kind === 'amount'
                    ? currencyFormat(discountCode.discount.value)
                    : `${discountCode.discount.value}%`
              })}
            </div>
          </>
        ) : (
          <div className="flex flex-row">
            <Trans
              i18nKey="events:eventDetails.discountAppliedLockIn"
              components={{
                strong: <strong className="mr-1" />
              }}
              values={{ code: discountCode.code }}
            />
          </div>
        )}
      </div>
    </div>
  ) : null;
}

export default DiscountCode;
